<template>
  <validation-provider :rules="rules" :name="`${tab}.${field}`" v-slot="{ valid, errors, changed }" :class="className">
    <b-form-radio-group
      :state="onValidateField(valid, errors, changed)"
      stacked
      @change="updateField"
      v-model="localField"
    >
      <template v-if="isBooleanField">
        <b-form-radio :value="true">Ja</b-form-radio>
        <b-form-radio :value="false">Nein</b-form-radio>
      </template>
      <template v-else>
        <b-radio
          v-for="radioValue in defaultValues"
          :value="radioValue.value"
          v-model="localField"
          :key="radioValue.value"
        >
          {{ radioValue.text }}
        </b-radio>
      </template>
    </b-form-radio-group>
    <b-form-invalid-feedback id="inputLiveFeedback">{{ errors[0] }}</b-form-invalid-feedback>
  </validation-provider>
</template>

<script>
  import { ValidationProvider } from 'vee-validate'
  import { mapState } from 'vuex'
  import { validateField } from '@/helpers/formHelper.js'

  export default {
    data: () => ({
      localField: ''
    }),
    created () {
      this.localField = this.getField
    },
    components: {
      ValidationProvider
    },
    props: {
      tab: {
        type: String,
        required: true
      },
      field: {
        type: String,
        required: true
      },
      defaultValues: {
        type: [String, Array, Boolean]
      },
      placeholder: String,
      className: String,
      rules: String,
      isBooleanField: Boolean,
      appendText: String
    },
    computed: mapState({
      getField (state) {
        const { tab, field } = this
        return state.calculator.formData[tab][field]
      }
    }),
    methods: {
      updateField (value) {
        const { tab, field } = this
        this.$store.commit('calculator/SET_FORMFIELD_VALUE', {
          tab,
          field,
          value
        })
      },
      onValidateField (valid, errors, changed) {
        return validateField(valid, errors, changed)
      }
    }
  }
</script>
